var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('global-layout',[(_vm.$store.getters.multiTab)?_c('multi-tab'):_vm._e(),_c('transition',{attrs:{"name":"page-transition"}},[_c('route-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }